import * as ActionType from './actionTypes';
import setAuthToken from '../../utils/setAuthToken';
import * as PageUrl from '../../utils/pageUrl'
// eslint-disable-next-line
import { postData, getDataWithToken, putDataWithToken } from './Services';

export const onRegisterUser = payload => {
  return {
    type: ActionType.USER_REGISTER_SUCCESS,
    payload,
  };
};
const onRegisterUserFail = payload => {
  return {
    type: ActionType.USER_REGISTER_FAIL,
    payload,
  };
};

const onLoginUser = payload => {
  return {
    type: ActionType.USER_LOGIN_SUCCESS,
    payload,
  };
};

const onLoginUserFail = payload => {
  return {
    type: ActionType.USER_LOGIN_FAIL,
    payload,
  };
};

export const onLoginUserCleanup = payload => {
  return {
    type: ActionType.USER_LOGIN_CLEANUP,
    payload,
  };
};


// export const setCurrentUser = decoded => {
//   return {
//     type: ActionType.SET_CURRENT_USER_USER,
//     payload: decoded,
//   };
// };

export const onForgotPasswordUser = payload => {
  return {
    type: ActionType.USER_FORGOT_PASSWORD_SUCCESS,
    payload,
  };
};
export const onForgotPasswordFail = payload => {
  return {
    type: ActionType.USER_FORGOT_PASSWORD_FAIL,
    payload,
  };
};

export const onGetUserData = payload => {
  return {
    type: ActionType.GET_AUTHENTICATED_USER,
    payload,
  };
};
export const onGetUserDataFail = payload => {
  return {
    type: ActionType.GET_AUTHENTICATED_USER_FAIL,
    payload,
  };
};

export const onPostImage = payload => {
  return {
    type: ActionType.USER_UPLOAD_DOC,
    payload,
  };
};






export const onChangeSuccess = payload => {
  return {
    type: ActionType.USER_CHANGE_PASSWORD_SUCCESS,
    payload,
  };
};

export const onChangeFail = payload => {
  return {
    type: ActionType.USER_CHANGE_PASSWORD_FAIL,
    payload,
  };
};



export const registerUser = (url, payload) => {
  return postData(url, payload, onRegisterUser, onRegisterUserFail);
};

export const loginUser = (url, payload) => {
  return postData(url, payload, onLoginUser, onLoginUserFail);
};

export const forgotPasswordUser = (url, payload) => {
  return postData(url, payload, onForgotPasswordUser, onForgotPasswordFail);
};
export const changePassword = (url, payload) => {
  return putDataWithToken(url, payload, onChangeSuccess, onChangeFail);
};

export const getUserData = (url) => {
  return getDataWithToken(url, onGetUserData, onGetUserDataFail)
}

export const logOutAction = () => {
  sessionStorage.removeItem('jwtToken');
  sessionStorage.clear();
  //remove auth header for feature request
  setAuthToken(false);
  window.location.href = PageUrl.LOGIN
};
